define(function (require) {
	const Backbone = require('backbone');
	const ViewManager = require('civicsUtils/view_manager');
	const favoriteContactsTemplate = require('civicsViews/favoriteContacts/templates/t_lov_select_favorite.hbs');
	const EmptyView = require('civicsViews/favoriteContacts/v_lov_empty_view');
	const FavoriteListView = require('civicsViews/favoriteContacts/v_clv_favorites');

	return Marionette.LayoutView.extend({
		className: 'favorites-container-modal',
		template: favoriteContactsTemplate,
		childEvents: {
			'selection:changed': 'onChildSelectionChanged'
		},
		regions: {
			listRegion: '.favorite-items',
			emptyMessageRegion: '.empty-message-container'
		},
		ui: {
			sortIcon: '.sort-arrow',
			searchInput: '#FavContactSearchInput',
			headerClass: '.favorites-region .header-container',
			sortDataButton: '[data-sort-type]'


		},
		events: {
			'input @ui.searchInput': 'onSearchInputChange',
			'click @ui.sortDataButton': 'sortDataClicked',

		},
		onChildSelectionChanged: function() {
			const selectedCount = this.collection.where({ isSelected: true }).length;
			this.$('.quantity-badge-container .count-selected').text(selectedCount);
			this.triggerMethod('change-state:nextBtn', selectedCount == 0);

		},	
		initialize: function (options) {
			this.config = options.config ? options.config : {};
			this.collection = options.collection;
			this.controller = options.controller;
			this.fullCollection = this.collection.clone();
			this.isSearching = false;
			this.selectedFavorites = options.selectedFavorites;
			this.isInviteProcess = options.isInviteProcess;
			this.listenTo(this.collection, 'change:isSelected', this.onChildSelectionChanged);
			this.listenTo(this.collection, 'reset', this.updateCollectionState);
		},

		onShow: function () {
		},
		onRender: function(){
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();
			  const listView = new FavoriteListView({
				collection: this.collection,
				selectedFavorites: this.selectedFavorites,
				config: this.config,
				isInviteProcess: this.isInviteProcess
			});
			this.showChildView('listRegion', listView);
			this.updateCollectionState();
		},
		updateCollectionState: function(){
			const emptyRegion = this.getRegion('emptyMessageRegion');
			if (this.collection.isEmpty()) {
				const message = this.isSearching
				? i18n.t('CIVICS.FAVORITES.NO_SEARCH_FOUND')
				: i18n.t('CIVICS.FAVORITES.EMPTY_MESSAGE');

				emptyRegion.show(new EmptyView({ message }));
				this.ui.headerClass.hide();
			} else {
				emptyRegion.empty(); // Hide the message if there are items
				this.ui.headerClass.show();
			}

		},
		onSearchInputChange() {
			const query = this.ui.searchInput.val().toLowerCase().trim();
			this.isSearching = !!query;

			if (!this.isSearching) {
				this.collection.reset(this.fullCollection.models);
				return;
			}

			const queryWords = query.split(/\s+/); // split by space

			const filtered = this.fullCollection.filter(model => {
				const firstName = model.get('firstName')?.toLowerCase() || '';
				const lastName = model.get('lastName')?.toLowerCase() || '';
				const fullName = `${firstName} ${lastName}`.trim();

				return queryWords.every(word => fullName.includes(word));
			});

			this.collection.reset(filtered);
		},
		//copied from manage authorized user.js
		sortDataClicked: function (e) {
			var target = $(e.currentTarget);
			var sortType = target.data('sort-type');

			var reverseSort = (this.sortType === sortType) ? !this.reverseSort : false;

			this.sortType = sortType;
			this.reverseSort = reverseSort;

			this.collection.comparator = this.controller.getComparator(sortType, reverseSort);

			this.collection.sort();

			var refreshedTarget = this.ui.sortDataButton.filter('[data-sort-type="' + this.sortType + '"]');
			var refreshedArrow = refreshedTarget.find('.sort-arrow');

			this.ui.sortIcon.removeClass('up down');
			this.ui.sortDataButton.removeAttr('aria-sort');

			if (this.reverseSort) {
				refreshedArrow.addClass('up');
				refreshedTarget.attr('aria-sort', 'descending');
			} else {
				refreshedArrow.addClass('down');
				refreshedTarget.attr('aria-sort', 'ascending');
			}

			return false;
		},		

		templateHelpers: function() {
			return {
				config: this.config, 
				contentMessage: this.isInviteProcess ? i18n.t('CIVICS.FAVORITES.DIALOG.INVITE_APPLICANT_MESSAGE') :  i18n.t('CIVICS.FAVORITES.DIALOG.ADD_APPLICANT_MESSAGE'),
				hasFavorites: this.collection?.length > 0
			};
		},
	});
});
